/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class FieldsRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let group = store.findRecord('school-options/group', params.group_id);
    let heading = store.findRecord('school-options/heading', params.heading_id);
    return hash({
      group,
      heading,
      fields: store.query('school-options/field', {
        optionHeadingId: params.heading_id,
      }),
      sets: store.findAll('school-options/set'),
    });
  }
}
